import { useTranslation } from "@impero-com/common/utils/i18n";
import { TableToolbar, TextTool } from "@impero-com/ui";
import { useOutletContext } from "react-router-dom";

import { AssignmentTable } from "org/user/components/AssignmentTable";
import { ReassignmentFailureAlert } from "org/user/components/ReassignmentFailureAlert";
import { ReplaceUserModal } from "org/user/components/ReplaceUserModal";
import { usePendingControlResultsForUserQuery } from "org/user/queries/usePendingControlResultsForUserQuery";
import { OutletContext } from "org/user/UserViewPage";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import { describeControlResultFailure } from "./describeControlResultFailure";
import { useReplaceControlResultUserUtils } from "./useReplaceControlResultUserUtils";
import {
    ControlResultRow,
    useUserControlResultListTable,
} from "./useUserControlResultListTable";

export function UserDirectControlResultsList() {
    const { user } = useOutletContext<OutletContext>();
    const userId = user.id;
    const { t } = useTranslation();

    const { data } = usePendingControlResultsForUserQuery(userId, "direct");

    const { table, getFilterComponent, canAddException, tableId } =
        useUserControlResultListTable(data, userId, "direct");

    const modeConfig = getFilterModeConfig(t);

    const selectedRows = table.getFilteredSelectedRowModel().rows;
    const deselectAll = () => table.resetRowSelection();

    const {
        replaceUserToolState,
        isReplaceUserModalOpen,
        replaceUserError,
        openReplaceUserModal,
        closeReplaceUserModal,
        replaceUser,
        isReplacingUser,
    } = useReplaceControlResultUserUtils({ userId, selectedRows, deselectAll });

    const replaceFailure = describeControlResultFailure(
        t,
        replaceUserError,
        data
    );

    return (
        <div>
            <ReplaceUserModal
                open={isReplaceUserModalOpen}
                replaceType="WithUser"
                loading={isReplacingUser}
                onClose={closeReplaceUserModal}
                onClick={replaceUser}
                user={user}
                error={
                    replaceFailure && (
                        <ReassignmentFailureAlert failure={replaceFailure} />
                    )
                }
            />
            <AssignmentTable<ControlResultRow>
                table={table}
                tableId={tableId}
                getFilterComponent={getFilterComponent}
                canAddException={canAddException}
                modeConfig={modeConfig}
                toolbar={
                    <TableToolbar>
                        <TextTool
                            state={replaceUserToolState}
                            onClick={openReplaceUserModal}
                        >
                            {t("AccessAndAssignment_Tool_ReplaceUser")}
                        </TextTool>
                    </TableToolbar>
                }
            />
        </div>
    );
}
